/* Idea return one array:
    0 info text before link
    1 link_exists (bool)
    2 link_word
    3 link
    4 info text after link
    5 image_exists (bool)
    6 image_link
    7 video_exists (bool)
    8 video_link
*/

export function extract_links_images_videos(string) {
    let end_array = []
    end_array.push(get_links(string))
    end_array.push(get_images(string))
    end_array.push(get_videos(string))
    return [].concat.apply([], end_array)
};

function get_links(string) {
    // return  1 infotext before, 2 link_exists, 3 link, 4 infotext_after
    let temp = string.split('!link')
    
    if (temp.length > 1) {
        return [temp[0], true, temp[1].split(' | ')[0], temp[1].split(' | ')[1], temp[2].split('!')[0]]
    }
    else {
        return [temp[0], false, null, null, temp]
    }
};

function get_images(string) {
    let temp = string.split('!image')
    if (temp.length > 1) { 
        return [true, temp[1]]
    }
    else {
        return [false, null]
    }
};

function get_videos(string) {
    let temp = string.split('!video')
    if (temp.length > 1) { 
        return [true, temp[1]]
    }
    else {
        return [false, null]
    }
}
